/* tslint:disable */
import {EmployeeDataUpdate} from '../../models';
import {Inject, Injectable, Optional} from '@angular/core';
import {Http} from '@angular/http';
import {SDKModels} from './SDKModels';
import {LoopBackConfig} from '../../lb.config';
import {BaseLoopBackApi, ErrorHandler, JSONSearchParams, LoopBackAuth} from '../core';
import {Observable} from 'rxjs/Rx';
import {SocketConnection} from '../../sockets/socket.connections';


/**
 * Api services for the `EmployeeDataUpdate` model.
 */
@Injectable()
export class EmployeeDataUpdateApi extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http, connection, models, auth, searchParams, errorHandler);
  }


  /**
   * <em>
   * (The remote method definition does not provide any description.)
   * </em>
   *
   * @param {object} sffilter
   *
   * @param {object} auth
   *
   * @param customHeaders
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   */
  public SFfind(sffilter: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/SFfind";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof sffilter !== 'undefined' && sffilter !== null) _urlParams.sffilter = sffilter;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * Find first instance of the model matched by filter from the data source.
   *
   * @param {object} sffilter
   *
   * @param {object} auth
   *
   * @param customHeaders
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   */
  public SFfindOne(sffilter: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/SFfindOne";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof sffilter !== 'undefined' && sffilter !== null) _urlParams.sffilter = sffilter;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * Count instances of the model matched by where from the data source.
   *
   * @param {object} sfwhere
   *
   * @param {object} auth
   *
   * @param customHeaders
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `count` – `{number}` -
   */
  public SFcount(sfwhere: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/SFcount";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof sfwhere !== 'undefined' && sfwhere !== null) _urlParams.sfwhere = sfwhere;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * Find a model instance by {{id}} from the data source.
   *
   * @param {any} id Model id
   *
   * @param {object} sffilter Filter defining fields and include
   *
   * @param {object} auth
   *
   * @param customHeaders
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   */
  public SFfindById(id: any, sffilter: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/SFfindById:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof sffilter !== 'undefined' && sffilter !== null) _urlParams.sffilter = sffilter;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * Create a new instance of the model and persist it into the data source.
   *
   *
   *  - `sfdata` – `{object}` - Model instance data
   *
   *  - `auth` – `{object}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   * @param sfdata
   * @param auth
   * @param customHeaders
   */
  public SFcreate(sfdata: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/SFcreate";
    let _routeParams: any = {};
    let _postBody: any = {
      sfdata: sfdata
    };
    let _urlParams: any = {};
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   *
   *
   *  - `sfdata` – `{object}` - Model instance data
   *
   *  - `auth` – `{object}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   * @param sfdata
   * @param auth
   * @param customHeaders
   */
  public SFupsert(sfdata: any = {}, auth: any = {}, customHeaders?: Function): Observable<EmployeeDataUpdate> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/SFupsert";
    let _routeParams: any = {};
    let _postBody: any = {
      sfdata: sfdata
    };
    let _urlParams: any = {};
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * Update an existing model instance or insert a new one into the data source based on the where criteria.
   *
   * @param {object} sfwhere Criteria to match model instances
   *
   * @param sfdata
   * @param auth
   * @param customHeaders
   *
   *  - `sfdata` – `{object}` - An object of model property name/value pairs
   *
   *  - `auth` – `{object}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   */
  public SFupsertWithWhere(sfwhere: any = {}, sfdata: any = {}, auth: any = {}, customHeaders?: Function): Observable<EmployeeDataUpdate> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/SFupsertWithWhere";
    let _routeParams: any = {};
    let _postBody: any = {
      sfdata: sfdata
    };
    let _urlParams: any = {};
    if (typeof sfwhere !== 'undefined' && sfwhere !== null) _urlParams.sfwhere = sfwhere;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * Update instances of the model matched by {{where}} from the data source.
   *
   * @param {object} sfwhere Criteria to match model instances
   *
   * @param sfdata
   * @param auth
   * @param customHeaders
   *
   *  - `sfdata` – `{object}` - An object of model property name/value pairs
   *
   *  - `auth` – `{object}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Information related to the outcome of the operation
   */
  public SFupdateAll(sfwhere: any = {}, sfdata: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/SFupdate";
    let _routeParams: any = {};
    let _postBody: any = {
      sfdata: sfdata
    };
    let _urlParams: any = {};
    if (typeof sfwhere !== 'undefined' && sfwhere !== null) _urlParams.sfwhere = sfwhere;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * Delete a model instance by {{id}} from the data source.
   *
   * @param {any} id Model id
   *
   * @param customHeaders
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   */
  public SFdeleteById(id: any, customHeaders?: Function): Observable<any> {
    let _method: string = "DELETE";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * <em>
   * (The remote method definition does not provide any description.)
   * </em>
   *
   * @param {Object} params
   *
   * @param customHeaders
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   */
  public downloadTemplate(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/downloadTemplate";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * <em>
   * (The remote method definition does not provide any description.)
   * </em>
   *
   *
   *  - `container` – `{string}` -
   *
   *  - `file` – `{string}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `EmployeeDataUpdate` object.)
   * </em>
   * @param container
   * @param file
   * @param customHeaders
   */
  public save(container: any, file: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/EmployeeDataUpdate/:container/save";
    let _routeParams: any = {
      container: container
    };
    let _postBody: any = {
      file: file
    };
    let _urlParams: any = {};
    console.log('_postBody',_postBody)
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `EmployeeDataUpdate`.
   */
  public getModelName() {
    return "EmployeeDataUpdate";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/EmployeeDataUpdate.ts